import { pathOr } from "ramda";

export const momentToStr = (value, format) =>
  value && format && value.format(format);

export const getDataValueBasedOnStateValue = (data = [], stateId) => {
  const obj = data.find((item) => item.id.toString() === stateId);
  return (obj && obj.text) || "";
};

export const getValidationField = (obj, field, def = false) =>
  pathOr(def, ["valid", field], obj);
export const getFormDataField = (obj, field, def = null) =>
  pathOr(def, ["data", field], obj);
export const getFormStateField = (obj, field, def = null) =>
  pathOr(def, ["formState", field], obj);
export const getCurrentJob = (obj, field, def = null) =>
  pathOr(def, ["currentJob", field], obj);

const isSmoothScrollSupported = ((document || {}).documentElement || {}).style
  ? "scrollBehavior" in document.documentElement.style
  : false;

export const scrollToTop = () => {
  if (isSmoothScrollSupported) {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  } else {
    window.scrollTo(0, 0);
  }
};

export const scrollTo = (ycoordinate) => {
  if (isSmoothScrollSupported) {
    window.scroll({
      top: ycoordinate,
      left: 0,
      behavior: "smooth",
    });
  } else {
    window.scrollTo(0, ycoordinate);
  }
};

export const scrollToElement = (id) => {
  if (document.getElementById(id)) {
    if (isSmoothScrollSupported) {
      document.getElementById(id).scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      document.getElementById(id).scrollIntoView();
    }
  }
};

export const getHideCompText = (value = "") =>
  value === "Hide Compensation" || (value && value.toString() === "true")
    ? "Hide Compensation"
    : "Show Compensation";

export default {
  momentToStr,
  getDataValueBasedOnStateValue,
  scrollToTop,
  scrollTo,
  scrollToElement,
  getValidationField,
  getFormDataField,
  getFormStateField,
};
